<script>
import { BMedia } from "bootstrap-vue";

export default {
  extends: BMedia
};
</script>